/**
 * Shared company list used across the application.
 * Used in: Home filters, Policy filters, UploadDialog, etc.
 */
export const COMPANIES = [
  { value: "", label: "全部公司" },
  { value: "ant", label: "蚂蚁" },
  { value: "bytedance", label: "字节" },
  { value: "meituan", label: "美团" },
  { value: "jd", label: "京东" },
] as const;

/**
 * Company display names without "全部公司" option.
 * Used for selector-only scenarios (e.g., upload dialog).
 */
export const COMPANY_OPTIONS = COMPANIES.filter(c => c.value !== "");

/**
 * Source code to company name mapping.
 */
export const SOURCE_COMPANY: Record<string, string> = {
  ant_official: "蚂蚁",
  bytedance_official: "字节",
  meituan_official: "美团",
  jd_official: "京东",
};
